import { useEffect, useState, useRef, useContext } from 'react';
import { Box, useTheme, Button } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../theme";
import SaveIcon from '@mui/icons-material/Save';
import Header from "../components/Header";
import useAxiosPrivate from "../hooks/useAxiosPrivate"
import saveSettings from './managers/saveSettings';
import { useNavigate, useLocation } from 'react-router-dom';
import { SettingsBarContext } from '../context/SettingsBarContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import handleError from "../hooks/handleError";


const Settings = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();
    const location = useLocation();
    var [settings, setSettings] = useState([]);
    var [DisplayedSettings, setDisplayedSettings] = useState([]);
    var [saveSettingsError, setSaveSettingsErr] = useState('');
    var err = false;
    const errRef = useRef();
    const effectRan = useRef(false);
    var isMounted = false;
    const controller = new AbortController();
    const { isSettingsBarOpen, toggleSettingsBar } = useContext(SettingsBarContext);

    useEffect(() => {
        if (isSettingsBarOpen) {
            toggleSettingsBar();
        }
        return () => {
            effectRan.current = true;
        }
    }, [])

    // Get Settings
    useEffect(() => {
        if (effectRan.current === false) {
            let isMounted = true;
            const controller = new AbortController();

            const getSettings = async () => {
                try {
                    var getSettingsResponse = await axiosPrivate.get('/Settings', {
                        signal: controller.signal
                    });
                    isMounted && setSettings(getSettingsResponse.data)
                    setDisplayedSettings(getSettingsResponse.data);
                } catch (err) {
                    if ((err.response?.status === 401) || (err.response?.status === 403)) {
                        navigate('/sign-in', { state: { from: location }, replace: true });
                    }
                    else {
                        handleError(err);
                    }
                }
            }

            getSettings();
            effectRan.current = true;
        }

        return () => {
            isMounted = false;
            controller.abort();

        }

    }, [])

    const processRowUpdate = (newRow) => {
        const updatedRow = { ...newRow, actions: ((newRow.actions !== "INSERT" & newRow.actions !== "DELETE") ? "UPDATE" : newRow.actions) };
        setSettings(settings.map((row) => (row.id === updatedRow.id ? updatedRow : row)));
        setDisplayedSettings(DisplayedSettings.map((row) => ((row.id === updatedRow.id & updatedRow.actions !== "DELETE") ? updatedRow : row)));
        return updatedRow;
    };

    const saveChangesHandler = event => {
        try {
            err = saveSettings(settings);
        } catch (err) {
            handleError(err);
        }

        if (!err) {
            var updatedArray = settings.filter((row) => row.actions !== "DELETE")
            updatedArray = updatedArray.map(row => ({ ...row, actions: null }));
            setSettings(updatedArray)
        }
        err = false;
    }

    const SettingsColumns = [
        {
            field: "sort_key",
            headerName: "Priority",
            headerAlign: 'center',
            width: 100,
            align: 'center',
            editable: true,
        },
        {
            field: "setting",
            headerName: "Setting",
            headerAlign: 'center',
            width: 400,
            align: 'left',
            editable: true,
        },
        {
            field: "value",
            headerName: "Value",
            headerAlign: 'center',
            width: 400,
            align: 'left',
            editable: true,
        },
        {
            field: "value_2",
            headerName: "Value 2",
            headerAlign: 'center',
            width: 400,
            align: 'left',
            editable: true,
        },



    ];

    return (
        <Box m="20px">

            <Header
                title="Settings"
                titleSize="h2"
                subtitle="C'mon you should know what settings are."
                subtitleSize="h5"
            />
            < ToastContainer />

            <Box
                m="40px 0 0 0"
                height="67vh"
                sx={{
                    "& .MuiDataGrid-root": {
                        border: "none",
                    },
                    "& .MuiDataGrid-cell": {
                        borderBottom: "none",
                    },
                    "& .name-column--cell": {
                        color: colors.greenAccent[300],
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.blueAccent[400],
                        borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                        borderTop: "none",
                        backgroundColor: colors.blueAccent[400],
                    },
                    "& .MuiCheckbox-root": {
                        color: `${colors.greenAccent[200]} !important`,
                    },
                    "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                        color: `${colors.grey[100]} !important`,
                    },
                }}
            >

                < DataGrid

                    rows={DisplayedSettings}
                    columns={SettingsColumns}
                    processRowUpdate={processRowUpdate}
                    experimentalFeatures={{ newEditingApi: true }}
                    components={{ Toolbar: GridToolbar }
                    }
                    sx={
                        {
                            fontSize: 15,
                            '& .MuiDataGrid-cell:edit': {
                                fontSize: 10,
                            },
                            CanUserResizeColumns: true,
                        }

                    }
                />
            </Box>
            <Box padding="1rem" align="right">
                <p ref={errRef} className={saveSettingsError ? "errmsg" :
                    "offscreen"} aria-live="assertive">{saveSettingsError}</p>
                <Button onClick={saveChangesHandler}
                    sx={{
                        backgroundColor: colors.greenAccent[500],
                        color: "#ffffff",
                        '&:hover': {
                            backgroundColor: colors.greenAccent[300],
                            color: "#ffffff",
                        },
                        fontSize: "14px",
                        fontWeight: "bold",
                        padding: "10px 20px",
                    }}
                >
                    <SaveIcon sx={{ mr: "10px" }} />
                    Save Changes
                </Button>
            </Box>
        </Box>

    )
};


export default Settings;


